import React, { Component } from 'react'
import ProductSelect from '../../../common/product-selection/selection.component.jsx'
import {AppContext} from '@lightspeed-invoicing/core-client/frontend'
import {FormattedMessage} from 'react-intl'

class AssemblyChoiceEditForm extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            id: this.props.choice.id,
            productId: this.props.choice.productId,
            additionalUnitPrice: '0',
            sequence: this.props.choice.sequence,
        }
        const defaultCallback = () => {}
        this.onChange = this.props.onChange || defaultCallback
        this.onDelete = this.props.onDelete || defaultCallback
        this.handleFormChange = this.handleFormChange.bind(this)
        this.handleProductChange = this.handleProductChange.bind(this)
        this.deleteChoice = this.deleteChoice.bind(this)
    }

    componentDidMount() {}

    handleFormChange(event) {
        const target = event.target
        const value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.name

        this.setState({
            [name]: value
        }, () => {
            this.choiceChanged()
        })
    }

    handleProductChange(productId) {
        if (productId) {
            AppContext.getApiClient().get('/products/' + productId).then(res => {
                this.setState({
                    productId: productId,
                }, () => {
                    this.choiceChanged()
                })
            })
        } else {
            this.setState({
                productId: productId,
            }, () => {
                this.choiceChanged()
            })
        }


    }

    getCurrentChoiceObject() {
        return {
            id: this.state.id,
            productId: this.state.productId,
            additionalUnitPrice: this.state.additionalUnitPrice,
            sequence: this.state.sequence,
        }
    }

    choiceChanged() {
        this.onChange(this.getCurrentChoiceObject())
    }

    deleteChoice(event) {
        this.onDelete(this.getCurrentChoiceObject())
        event.preventDefault()
    }

    render() {
        return (
            <div className="row">
                <div className="col-12 py-1 border-bottom">
                    <div className="form-group">
                        <label htmlFor="exampleFormControlInput1">
                            <FormattedMessage
                                id="product.calculator.form.edit.product_choice_label"
                                defaultMessage="Product choice"
                            />
                        </label>
                        <ProductSelect name="productId" value={this.state.productId} onChange={this.handleProductChange} />
                    </div>
                    <div className="form-group">
                        <button className="btn btn-danger btn-sm" onClick={this.deleteChoice}>
                            <FormattedMessage
                                id="product.calculator.form.edit.delete_choice_btn"
                                defaultMessage="Delete choice"
                            />
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default AssemblyChoiceEditForm


// WEBPACK FOOTER //
// ./src/product/form/assembly/choice.component.jsx